var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 168 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7 0H109.7C141.4 0 167.4 26 167.4 57.7V111.2C167.4 142.9 141.4 168.9 109.7 168.9H57.7C26 168.9 0 142.9 0 111.2V57.7C0 26 26 0 57.7 0Z",
    fill: "url(#paint0_linear_1059_3252)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M99.2998 131.1L139.1 91.3003C147.5 82.9003 147.5 69.1003 139.1 60.6003C130.7 52.2003 116.9 52.2003 108.4 60.6003L68.5998 100.4C60.1998 108.8 60.1998 122.6 68.5998 131.1C76.9998 139.5 90.8998 139.5 99.2998 131.1Z",
    fill: "url(#paint1_linear_1059_3252)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M68.2001 131.1L28.4001 91.3003C20.0001 82.9003 20.0001 69.1003 28.4001 60.6003C36.8001 52.2003 50.6 52.2003 59.1 60.6003L98.9001 100.4C107.3 108.8 107.3 122.6 98.9001 131.1C90.4001 139.5 76.6001 139.5 68.2001 131.1Z",
    fill: "url(#paint2_linear_1059_3252)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1059_3252",
    x1: 16.5874,
    y1: 151.562,
    x2: 150.812,
    y2: 17.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E72144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#76549E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1059_3252",
    x1: 138.95,
    y1: 60.7498,
    x2: 68.4505,
    y2: 131.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    stopColor: "#EBE8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF3F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1059_3252",
    x1: 28.4001,
    y1: 60.6003,
    x2: 98.9001,
    y2: 131.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    stopColor: "#EBE8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF3F7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/Logo_Header.8ca7ecdcbe15843e2d41ac8eb5fad5a2.svg";
export { ForwardRef as ReactComponent };